import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { Container } from '../../layout/Container'
import { Accordion } from '../../ui/Accordion'
import { useScrollAnimation } from '../../../hooks/useScrollAnimation'

interface FAQItem {
  id: string
  question: string
  answer: string
}

interface ModuleFAQProps {
  tKey: 'brain' | 'build' | 'govern'
}

export function ModuleFAQ({ tKey }: ModuleFAQProps) {
  const { t } = useTranslation()
  const { ref, isInView } = useScrollAnimation()

  const items = t(`platformPages.${tKey}.faq.items`, { returnObjects: true }) as FAQItem[]
  const accordionItems = items.map((item) => ({
    id: item.id,
    title: item.question,
    content: item.answer,
  }))

  return (
    <section ref={ref} className="border-t border-border bg-surface py-24">
      <Container size="narrow">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <span className="text-sm font-medium uppercase tracking-wider text-accent-light">
            {t(`platformPages.${tKey}.faq.label`)}
          </span>
          <h2 className="mt-4 text-3xl font-semibold tracking-tight text-text-primary sm:text-4xl">
            {t(`platformPages.${tKey}.faq.title`)}
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.15 }}
          className="mt-12"
        >
          <Accordion items={accordionItems} />
        </motion.div>
      </Container>
    </section>
  )
}
